import { render } from "./BaseTooltip.vue?vue&type=template&id=68c5e916&ts=true"
import script from "./BaseTooltip.vue?vue&type=script&lang=ts"
export * from "./BaseTooltip.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__